var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEnterPinIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_20581_16389)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 66C59.6731 66 74 51.6731 74 34C74 16.3269 59.6731 2 42 2C24.3269 2 10 16.3269 10 34C10 51.6731 24.3269 66 42 66Z",
    fill: "#FFB717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 26.0169C26.002 27.7741 27.3283 29.1981 28.9651 29.2002H35.589C36.0852 29.2002 36.4875 28.7683 36.4875 28.2356C36.4875 27.7028 36.0852 27.2709 35.589 27.2709H28.9651C28.32 27.2709 27.797 26.7095 27.797 26.0169V20.3835C27.797 19.6909 28.32 19.1295 28.9651 19.1295H50.2349C50.88 19.1295 51.403 19.6909 51.403 20.3835V26.0169C51.403 26.3495 51.2799 26.6685 51.0608 26.9036C50.8418 27.1388 50.5447 27.2709 50.2349 27.2709H47.852C47.3558 27.2709 46.9535 27.7028 46.9535 28.2356C46.9535 28.7683 47.3558 29.2002 47.852 29.2002H50.2349C51.8717 29.1981 53.198 27.7741 53.2 26.0169V20.3835C53.198 18.6263 51.8717 17.2023 50.2349 17.2002H28.9651C27.3283 17.2023 26.002 18.6263 26 20.3835V26.0169Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6008 23.6C36.0426 23.6 36.4008 23.2418 36.4008 22.8C36.4008 22.3582 36.0426 22 35.6008 22C35.159 22 34.8008 22.3582 34.8008 22.8C34.8008 23.2418 35.159 23.6 35.6008 23.6Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6952 35.9758C52.7999 33.6328 49.1839 32.3857 45.4736 32.4506L45.3083 24.1742C45.2793 22.5383 43.9684 21.2215 42.3478 21.2002H42.2903C40.6594 21.2055 39.3277 22.5176 39.2831 24.1633L38.9022 40.1684C38.7483 40.0706 38.6112 39.9481 38.4962 39.8058L37.3142 37.7639C36.3459 36.1004 34.4838 35.1856 32.5896 35.4427C31.9234 35.5327 31.3425 35.9447 31.0328 36.5468C30.7231 37.149 30.7235 37.8657 31.0339 38.4675L35.5716 47.2915C35.8029 47.7352 36.1038 48.1382 36.4627 48.4847C36.8746 48.8713 37.3548 49.1764 37.8783 49.3842L39.7214 50.1567L39.7897 50.1821C40.1959 50.3156 40.5165 50.6339 40.6555 51.0416L40.8927 51.7344C40.9973 52.0408 41.2559 52.2676 41.5711 52.3294C41.8863 52.3912 42.2102 52.2785 42.4208 52.0338C42.6314 51.7891 42.6967 51.4496 42.5921 51.1432L42.355 50.4505C42.035 49.5188 41.3072 48.7881 40.3825 48.4702L38.586 47.7122C38.2684 47.59 37.9759 47.4092 37.7238 47.1791C37.5065 46.9683 37.3245 46.7233 37.1848 46.4537L32.6399 37.6297C32.6007 37.5527 32.6007 37.4614 32.6399 37.3844C32.6791 37.3074 32.7527 37.2543 32.8375 37.2416C34.0149 37.0853 35.1704 37.6571 35.7692 38.6923L36.9764 40.7814C36.9948 40.8129 37.0152 40.8432 37.0375 40.872C37.81 41.9057 39.1717 42.5658 40.2711 41.8295C40.5136 41.6677 40.6635 41.3974 40.6735 41.1042L41.0831 24.2358C41.1182 23.5857 41.6506 23.0766 42.2957 23.0766C42.9407 23.0766 43.4732 23.5857 43.5083 24.2358L43.6915 33.4588C43.6964 33.7171 43.8102 33.961 44.0044 34.1293C44.1986 34.2976 44.4546 34.3743 44.7083 34.3402C48.2579 34.0782 51.775 35.175 54.5599 37.4121C55.0991 37.8564 55.4107 38.5228 55.4078 39.2255V44.7491C55.4078 46.8781 54.0605 48.4992 53.4785 49.1013C53.1115 49.4764 52.8307 49.9283 52.6557 50.4251L52.4042 51.1504C52.2788 51.4601 52.3326 51.8144 52.544 52.072C52.7555 52.3296 53.0903 52.4487 53.4151 52.3819C53.7398 52.3151 54.0017 52.0731 54.0964 51.7525L54.3479 51.0271C54.4365 50.7794 54.5775 50.5542 54.7611 50.3671C55.6737 49.4277 57.2007 47.4438 57.2007 44.7491V39.211C57.2104 37.958 56.6567 36.7683 55.6952 35.9758Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6008 23.6C32.0426 23.6 32.4008 23.2418 32.4008 22.8C32.4008 22.3582 32.0426 22 31.6008 22C31.159 22 30.8008 22.3582 30.8008 22.8C30.8008 23.2418 31.159 23.6 31.6008 23.6Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6008 23.6C48.0426 23.6 48.4008 23.2418 48.4008 22.8C48.4008 22.3582 48.0426 22 47.6008 22C47.159 22 46.8008 22.3582 46.8008 22.8C46.8008 23.2418 47.159 23.6 47.6008 23.6Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_20581_16389",
    x: 0,
    y: 0,
    width: 84,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.209409 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20581_16389"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_20581_16389",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEnterPinIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/enterPinIcon.eab0e07133c6a41a512d86fbf30e0054.svg";